import { NEXT_OF_KIN_RELATIONSHIP_CODES } from "$routes/_lib/constants";
import React from "react";
import { defineMessage, useIntl } from "react-intl";

const nextOfKinRelationshipMap = {
  [NEXT_OF_KIN_RELATIONSHIP_CODES.HUSBAND]: defineMessage({
    id: "nextOfKinRelatioinship.husband",
    defaultMessage: "Husband",
  }),
  [NEXT_OF_KIN_RELATIONSHIP_CODES.WIFE]: defineMessage({
    id: "nextOfKinRelatioinship.wife",
    defaultMessage: "Wife",
  }),
  [NEXT_OF_KIN_RELATIONSHIP_CODES.BROTHER]: defineMessage({
    id: "nextOfKinRelatioinship.brother",
    defaultMessage: "Brother",
  }),
  [NEXT_OF_KIN_RELATIONSHIP_CODES.SISTER]: defineMessage({
    id: "nextOfKinRelatioinship.sister",
    defaultMessage: "Sister",
  }),
  [NEXT_OF_KIN_RELATIONSHIP_CODES.FATHER]: defineMessage({
    id: "nextOfKinRelatioinship.father",
    defaultMessage: "Father",
  }),
  [NEXT_OF_KIN_RELATIONSHIP_CODES.MOTHER]: defineMessage({
    id: "nextOfKinRelatioinship.mother",
    defaultMessage: "Mother",
  }),
  [NEXT_OF_KIN_RELATIONSHIP_CODES.CHILD]: defineMessage({
    id: "nextOfKinRelatioinship.child",
    defaultMessage: "Child",
  }),
  [NEXT_OF_KIN_RELATIONSHIP_CODES.FRIEND]: defineMessage({
    id: "nextOfKinRelatioinship.friend",
    defaultMessage: "Friend",
  }),
  [NEXT_OF_KIN_RELATIONSHIP_CODES.OTHER]: defineMessage({
    id: "nextOfKinRelatioinship.other",
    defaultMessage: "Other",
  }),
};

const useNextOfKinRelationshipTranslation = () => {
  const { formatMessage } = useIntl();

  const translateNextOfKinRelationshipCode = React.useCallback(
    (nextOfKinRelationshipCode) =>
      formatMessage(
        nextOfKinRelationshipMap[nextOfKinRelationshipCode] ||
          nextOfKinRelationshipMap[NEXT_OF_KIN_RELATIONSHIP_CODES.OTHER],
      ),
    [formatMessage],
  );

  const nextOfKinRelationships = React.useMemo(
    () =>
      Object.values(NEXT_OF_KIN_RELATIONSHIP_CODES).map((code) => ({
        name: translateNextOfKinRelationshipCode(code),
        code,
      })),
    [translateNextOfKinRelationshipCode],
  );

  return { nextOfKinRelationships, translateNextOfKinRelationshipCode };
};

export default useNextOfKinRelationshipTranslation;
